export const translations = {
  da: {
    nav: {
      home: 'Forside',
      services: 'Ydelser',
      about: 'Om',
      experience: 'Erfaring',
      projects: 'Projekter',
      customers: 'Kunder',
      comparison: 'Sammenlign',
      faq: 'FAQ',
      contact: 'Kontakt',
      shop: 'Shop'
    },
    hero: {
      headline: 'Affiliate marketing, content og strategisk kommunikation med tyngde',
      subheadline: 'Jeg hjælper webshops, brands og virksomheder med at skabe stærkere partnerskaber, skarpere content og bedre kommerciel kommunikation — med afsæt i journalistik, relationer og 10 års erfaring med affiliate marketing.',
      intro: 'Jeg har arbejdet med journalistik, siden jeg var 15, og de seneste 10 år har jeg arbejdet med affiliate marketing i alle dets aspekter. I dag hjælper jeg danske og internationale kunder med at skabe resultater gennem skarp formidling, stærke samarbejder og en praktisk forståelse for både forretning, content og mennesker.',
      primaryCta: 'Book en uforpligtende samtale',
      secondaryCta: 'Se mine ydelser',
      trustLine: 'Journalistik. Affiliate. Content. Relationer. AI. Forretning.'
    },
    services: {
      heading: 'Ydelser & Kompetencer',
      categories: [
        {
          title: 'Affiliate-vækst & partnerskaber',
          items: [
            {
              title: 'Affiliate marketing strategi',
              desc: 'Jeg hjælper med at styrke eller gentænke jeres affiliate-indsats, så den hænger sammen med jeres forretning, målgruppe og øvrige marketingarbejde.',
              icon: 'TrendingUp'
            },
            {
              title: 'Affiliate partnerskaber og publisher relations',
              desc: 'Jeg hjælper med at opbygge, udvikle og vedligeholde stærke relationer til partnere og publishers. Affiliate handler om tillid og dialog.',
              icon: 'Users'
            }
          ]
        },
        {
          title: 'Content & redaktionel kvalitet',
          items: [
            {
              title: 'Contentstrategi',
              desc: 'Jeg udvikler content, der giver mening både redaktionelt og kommercielt. Fokus på struktur, vinkler og forretningsmål.',
              icon: 'FileText'
            },
            {
              title: 'SEO-nært og kommercielt content',
              desc: 'Jeg hjælper med at skrive og udvikle indhold, der både er læsbart, troværdigt og skabt med blik for synlighed og brugerintention.',
              icon: 'Search'
            },
            {
              title: 'Redaktionel udvikling',
              desc: 'Jeg hjælper med at skærpe tone, kvalitet og struktur i jeres indhold og redaktionelle processer.',
              icon: 'Edit3'
            }
          ]
        },
        {
          title: 'AI & Automation i praksis',
          items: [
            {
              title: 'AI-implementering i redaktionelle processer',
              desc: 'Hjælp til at bruge AI til at optimere indholdsproduktion, research og struktur uden at miste den menneskelige kvalitet.',
              icon: 'Cpu'
            },
            {
              title: 'Prompt engineering til marketing og content',
              desc: 'Udvikling af skræddersyede prompts og workflows, der sikrer præcis og brugbar output fra AI-modeller.',
              icon: 'Code'
            }
          ]
        },
        {
          title: 'Strategisk sparring & tværfaglig eksekvering',
          items: [
            {
              title: 'Digital PR og brandkommunikation',
              desc: 'Jeg hjælper med at styrke historier og kommunikation, så I står tydeligere over for omverden og samarbejdspartnere.',
              icon: 'Mic'
            },
            {
              title: 'Strategisk sparring',
              desc: 'En erfaren sparringspartner, der hurtigt forstår situationen og kan pege på, hvad der faktisk skaber værdi.',
              icon: 'Compass'
            },
            {
              title: 'Brobygning mellem teams',
              desc: 'Jeg arbejder i krydsfeltet mellem marketing, content, affiliate og udvikling for at skabe fælles retning.',
              icon: 'GitMerge'
            }
          ]
        }
      ]
    },
    about: {
      heading: 'Erfaring, vedholdenhed og en stærk forståelse for både content og forretning',
      body: [
        'Jeg har beskæftiget mig med journalistik, siden jeg var 15 år gammel. Siden da har formidling, indhold og redaktionel kvalitet været en rød tråd gennem hele mit arbejdsliv. Over årene har jeg opbygget en solid baggrund inden for journalistik, content, digital PR og redaktionelt arbejde.',
        'De sidste 10 år har samtidig arbejdet indgående med affiliate marketing og alle de discipliner, der følger med: relationer, partnerskaber, content, performance, koordinering og kommerciel forståelse. Det gør, at jeg ikke kun ser på indhold isoleret, men forstår, hvordan content, samarbejder og forretning hænger sammen i praksis.',
        'Jeg er vant til at være i dialog med både danske og internationale webshops, store brands, udviklere, studentermedhjælpere og mange andre samarbejdspartnere. Jeg trives i krydsfeltet mellem mennesker, processer og mål — og i rollen som den, der skaber fremdrift, overblik og kvalitet.',
        'Jeg lever med {{cp}}. Det betyder, at ingen veje i mit liv eller arbejdsliv har været lige. Til gengæld har det gjort mig ekstremt arbejdsom, vedholdende og løsningsorienteret. Det tager jeg med ind i alt, jeg laver: Jeg giver ikke hurtigt op, jeg arbejder grundigt, og jeg tager både opgaver og samarbejder seriøst.',
        'Konsulentbixen er mit afsæt for at arbejde med virksomheder, der har brug for mere end standardløsninger. Jeg hjælper, hvor der er behov for erfaring, præcision, troværdighed og en, der kan bygge bro mellem content, affiliate, relationer og forretning.'
      ],
      cp_label: 'cerebral parese',
      cp_tooltip: 'Cerebral parese (CP) er en blivende motorisk funktionsnedsættelse, der skyldes en skade i den umodne hjerne før, under eller kort efter fødslen. Det påvirker muskeltonus, bevægelse og motorik, men ikke intelligens.'
    },
    experience: {
      heading: 'Erfaring, der spænder bredt — og stadig hænger sammen',
      body: [
        'Min profil er bygget i krydsfeltet mellem journalistik, content, affiliate marketing, digital PR og redaktionelt arbejde. Det giver mig en sjælden kombination: Jeg kan både forstå detaljen og se helheden.',
        'Jeg har arbejdet med indhold, relationer og kommunikation i many forskellige sammenhænge og med many forskellige typer mennesker. Det betyder, at jeg hurtigt kan sætte mig ind i nye forretninger, udfordringer og samarbejder — og omsætte det til noget konkret og brugbart.'
      ],
      tags: [
        'Affiliate marketing',
        'Publisher relations',
        'Contentstrategi',
        'SEO-content',
        'AI-integration',
        'Prompt engineering',
        'Journalistik',
        'Redaktionel udvikling',
        'Digital PR',
        'Brandkommunikation'
      ]
    },
    projects: {
      heading: 'Egne projekter & cases',
      subheading: 'Ved siden af mit konsulentarbejde driver jeg en række egne projekter, hvor jeg tester strategier, optimerer performance og arbejder med affiliate marketing i praksis.',
      visitLink: 'Besøg siden',
      items: [
        {
          title: 'AutoReception',
          link: 'https://autoreception.net/',
          desc: 'En intelligent AI-løsning til automatiseret lead-håndtering og kundemodtagelse, der sikrer, at ingen henvendelser går tabt.',
          tags: ['AI', 'Automation', 'SaaS']
        },
        {
          title: 'Premium Affiliate',
          link: 'https://premiumaffiliate.io/',
          desc: 'En platform dedikeret til at løfte affiliate marketing gennem indsigt, værktøjer og strategisk sparring.',
          tags: ['Affiliate', 'Vækst', 'Strategi']
        },
        {
          title: 'Premium Conversion',
          link: 'https://premiumconversion.io/',
          desc: 'Optimering af konverteringsrater og brugerrejser med fokus på at skabe bedre resultater for publishers og webshops.',
          tags: ['CRO', 'Performance', 'UX']
        },
        {
          title: 'Premium Video',
          link: 'https://premiumvideo.io/',
          desc: 'Fokus på videoproduktion og visuel formidling til affiliate marketing og e-handel.',
          tags: ['Video', 'Content', 'Marketing']
        },
        {
          title: 'AccessInside',
          link: 'https://accessinside.net/',
          desc: 'Gør formel tilgængelighed til reel gæstekomfort. Praktiske tilgængeligheds-gennemgange for hoteller, krydstogtskibe og arenaer. Kombinerer en journalists øje for detaljen med levet erfaring.',
          tags: ['Tilgængelighed', 'Hospitality', 'UX']
        },
        {
          title: 'The Pitch Feed',
          link: 'https://thepitchfeed.com/',
          desc: 'Mit internationale fodbold-nyhedsbureau, der leverer nyheder på tværs af markeder og næsten alle sprog via automatiserede workflows.',
          tags: ['International', 'Nyhedsbureau', 'Automation']
        },
        {
          title: 'Fodbold i TV',
          link: 'https://fodbolditv.dk/da',
          desc: 'Danmarks nemmeste oversigt over fodboldkampe i tv. Siden har indbyggede affiliate-muligheder for bl.a. streamingtjenester og bookmakere.',
          tags: ['Forbruger', 'SEO', 'Affiliate']
        },
        {
          title: 'Shop Konsulentbixen',
          link: 'https://shop.konsulentbixen.dk/',
          desc: 'Min egen webshop, hvor jeg sælger udvalgte produkter og tester e-handelsstrategier af i praksis.',
          tags: ['E-handel', 'Webshop', 'Retail']
        },
        {
          title: 'Scorewidget',
          link: 'https://scorewidget.net/',
          desc: 'En B2B-løsning der leverer livescore-data og sportsindhold til publishers og mediehuse verden over.',
          tags: ['B2B', 'SaaS', 'Sportsdata']
        }
      ]
    },
    customers: {
      heading: 'Kunder & Samarbejder',
      subheading: 'Jeg arbejder med alt fra uddannelsesinstitutioner til internationale tech-virksomheder og webshops.',
      items: [
        {
          name: 'Danmarks Medie- og Journalisthøjskole',
          role: 'Beskikket censor',
          logo: 'https://gotutor.dk/img/@1/alumni/logo/danmarks-medie-og-journalisthoejskole-dmjx.png',
          desc: 'Beskikket censor i journalistik og digital journalistik. Her bidrager jeg til kvalitetssikring og vurdering af fremtidens journalister og deres faglige niveau.'
        }
      ]
    },
    comparison: {
      heading: 'Find den rette løsning til jeres behov',
      subheading: 'Uanset om I har brug for strategisk retning, velskrevet indhold eller hjælp til at vækste jeres affiliate-kanaler, kan jeg træde til.',
      cta: 'Hvilken løsning passer jer?',
      features: {
        strategy: 'Strategisk fokus',
        editorial: 'Journalistisk dybde',
        execution: 'Eksekvering & drift',
        relations: 'Relationsarbejde',
        ai: 'AI & Automation',
        international: 'Internationalt udsyn'
      },
      tiers: [
        {
          name: 'Affiliate & Partnerskaber',
          focus: 'Vækst & Relationer',
          desc: 'Fokus på at bygge bro mellem jeres brand og de rette publishers for at skabe målbar performance og langsigtede partnerskaber.',
          values: [80, 70, 100, 90, 40, 60]
        },
        {
          name: 'Content & Redaktion',
          focus: 'Kvalitet & SEO',
          desc: 'Udvikling af troværdigt og kommercielt indhold, der både taler til mennesker og søgemaskiner med redaktionel tyngde.',
          values: [60, 100, 50, 60, 100, 80]
        },
        {
          name: 'AI & Automation',
          focus: 'Effektivitet & Tech',
          desc: 'Implementering af AI-værktøjer og automatiserede workflows, der frigør tid og løfter kvaliteten i jeres daglige processer.',
          values: [90, 100, 60, 100, 70, 100]
        },
        {
          name: 'Strategisk sparring',
          focus: 'Retning & Udvikling',
          desc: 'Hjælp til at skabe overblik, prioritere indsatser og bygge bro mellem marketing, content og jeres overordnede forretningsmål.',
          values: [100, 50, 80, 80, 70, 90]
        }
      ]
    },
    faq: {
      heading: 'FAQ',
      items: [
        {
          q: 'Hvilke typer virksomheder arbejder du med?',
          a: 'Jeg arbejder især med webshops, brands, marketingteams, contentteams og virksomheder, der vil styrke affiliate marketing, content eller strategisk kommunikation.'
        },
        {
          q: 'Hvordan håndterer du fortrolighed og data?',
          a: 'Fortrolighed er en absolut præmis for mine samarbejder. Som uddannet journalist respekterer jeg fortrolighed på linje med kildebeskyttelse, som er et af journalistikkens mest hellige principper. Jeg arbejder ofte med følsomme forretningsdata og strategier, og jeg underskriver gerne en fortrolighedsaftale (NDA), før vi starter.'
        },
        {
          q: 'Arbejder du også med internationale kunder?',
          a: 'Ja. Jeg arbejder gerne med både danske og internationale virksomheder og er vant til dialog på tværs af markeder og samarbejdsformer.'
        },
        {
          q: 'Hjælper du kun med strategi?',
          a: 'Nej. Jeg kan hjælpe både strategisk og operationelt — fra analyse og retning til faktisk indhold, sparring og partnerskabsudvikling.'
        },
        {
          q: 'Hvad er din styrke sammenlignet med et klassisk bureau?',
          a: 'Min styrke er kombinationen af erfaring, faglig bredde, troværdighed og tæt involvering. Du arbejder direkte med en specialist, der forstår både journalistik, content, affiliate og relationer.'
        },
        {
          q: 'Kan du tilpasses mindre eller større projekter?',
          a: 'Ja. I kan gå ind i både afgrænsede opgaver, løbende samarbejder og større udviklingsforløb.'
        }
      ]
    },
    contact: {
      heading: 'Lad os tage en uforpligtende snak',
      body: 'Hvis du leder efter en erfaren samarbejdspartner inden for affiliate marketing, content eller strategisk kommunikation, tager jeg gerne en uforpligtende snak. Jeg arbejder med både danske og internationale kunder og går til alle opgaver med seriøsitet, skarphed og respekt for det, der skal skabes.',
      form: {
        name: 'Navn',
        email: 'E-mail',
        company: 'Virksomhed',
        message: 'Besked',
        send: 'Send beskeden'
      },
      sending: 'Sender...',
      success: 'Tak for din besked! Jeg vender tilbage til dig hurtigst muligt.',
      error: 'Der opstod en fejl. Prøv venligst igen eller send en mail direkte til kasper@konsulentbixen.dk.'
    },
    footer: {
      brand: 'Konsulentbixen',
      tagline1: 'Affiliate marketing, content og strategisk kommunikation',
      tagline2: 'For danske og internationale kunder',
      ivmh_text: 'Stolt medlem af Iværksættere med handicap',
      privacy: 'Cookie- og privatlivspolitik',
      terms: 'Forretnings- og leveringsbetingelser'
    },
    whyMe: {
      heading: 'En specialist med både dybde, overblik og gennemslagskraft',
      statement: 'Jeg kombinerer redaktionel kvalitet med kommerciel forståelse og en praktisk evne til at få ting til at ske.',
      items: [
        {
          title: 'Journalistisk fundament',
          desc: 'Jeg forstår, hvordan man skaber indhold med kvalitet, troværdighed og præcision.'
        },
        {
          title: '10 års affiliate-erfaring',
          desc: 'Jeg kender discipliner, dynamikker og samarbejder indefra.'
        },
        {
          title: 'AI & Tech forståelse',
          desc: 'Jeg følger tæt med i den teknologiske udvikling og forstår, hvordan AI kan bruges som en løftestang for både kvalitet og effektivitet.'
        },
        {
          title: 'Kommerciel forståelse',
          desc: 'Jeg tænker ikke kun i ord og indhold, men i værdi, performance og forretning.'
        },
        {
          title: 'Stærk relationel profil',
          desc: 'Jeg er vant til at arbejde med mange forskellige typer mennesker og interessenter.'
        },
        {
          title: 'Vedholdenhed',
          desc: 'Jeg arbejder hårdt, tænker mig om og bliver ved, når noget er vigtigt.'
        }
      ]
    },
    target: {
      heading: 'Jeg arbejder med virksomheder, der har brug for mere end standardløsninger',
      body: 'Jeg samarbejder især med virksomheder og teams, der har brug for en erfaren profil, som kan gå ind i komplekse opgaver og skabe retning, kvalitet og fremdrift.',
      items: [
        {
          title: 'Webshops',
          desc: 'der vil styrke deres affiliate-setup, content eller samarbejder'
        },
        {
          title: 'Brands',
          desc: 'der vil stå skarpere i deres kommunikation og partnerskaber'
        },
        {
          title: 'Marketingteams',
          desc: 'der har brug for en erfaren sparringspartner med kommerciel forståelse'
        },
        {
          title: 'Content- og redaktionelle teams',
          desc: 'der vil løfte kvalitet, struktur og effekt'
        },
        {
          title: 'Internationale virksomheder',
          desc: 'der ønsker en samarbejdspartner med både lokal forståelse og internationalt udsyn'
        }
      ]
    },
    testimonials: [
      {
        quote: 'Kasper er blandt de mest idérige, forretningsorienterede og nysgerrige profiler, jeg har mødt i mediebranchen. Jeg ville hyre ham uden at blinke.',
        author: 'Per Olkjær Nielsen',
        role: 'Redaktionschef',
        image: 'https://media.licdn.com/dms/image/v2/D4D22AQGB5G5mm8SB8g/feedshare-shrink_800/feedshare-shrink_800/0/1715610523658?e=2147483647&v=beta&t=SkQ0MU1ISvBcoH45wAHMltMmh230m0bpaSmlnuwxlK4',
        link: 'https://www.linkedin.com/in/perolkjaer/'
      },
      {
        quote: 'Vi byggede affiliate forretningen op, og lagde stenene til det som er i dag. Det var Kasper en stor og vigtig del af, og han kan være stolt af det vi fik skabt for Berlingske-huset',
        author: 'Jacob Fischer-Nielsen',
        role: 'Salgschef, Berlingske Media',
        image: 'https://media.licdn.com/dms/image/v2/C4E03AQG1gOr8m8X-gA/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1628511287164?e=1781740800&v=beta&t=CYwQ19oz8kgElPZeqZkAD6X4dZmJ3d-53ozddrXaFv0',
        link: 'https://www.linkedin.com/in/jacob-fischer-nielsen-9a09907/'
      }
    ],
    seo: {
      title: 'Konsulentbixen | Affiliate marketing, content og strategisk kommunikation',
      description: 'Konsulentbixen hjælper danske og internationale virksomheder med affiliate marketing, content, journalistik, digital PR og strategisk kommunikation. Erfaren specialist med stærk kommerciel og redaktionel forståelse.'
    }
  },
  en: {
    nav: {
      home: 'Home',
      services: 'Services',
      about: 'About',
      experience: 'Experience',
      projects: 'Projects',
      customers: 'Clients',
      comparison: 'Compare',
      faq: 'FAQ',
      contact: 'Contact',
      shop: 'Shop'
    },
    hero: {
      headline: 'Affiliate marketing, content, and strategic communication with substance',
      subheadline: 'I help ecommerce businesses, brands, and companies build stronger partnerships, sharper content, and better commercial communication — grounded in journalism, relationships, and 10 years of affiliate marketing experience.',
      intro: 'I have worked with journalism since I was 15, and for the last 10 years I have worked with affiliate marketing in all its aspects. Today, I help Danish and international clients create results through sharp communication, strong collaboration, and a practical understanding of business, content, and people.',
      primaryCta: 'Book an exploratory call',
      secondaryCta: 'Explore services',
      trustLine: 'Journalism. Affiliate. Content. Relationships. AI. Business.'
    },
    services: {
      heading: 'Services & Expertise',
      categories: [
        {
          title: 'Affiliate growth & partnerships',
          items: [
            {
              title: 'Affiliate marketing strategy',
              desc: 'I help strengthen or rethink your affiliate setup so it aligns with your business, audience, and wider marketing efforts.',
              icon: 'TrendingUp'
            },
            {
              title: 'Affiliate partnerships and publisher relations',
              desc: 'I help build, develop, and maintain strong relationships with partners and publishers. Affiliate is about trust and dialogue.',
              icon: 'Users'
            }
          ]
        },
        {
          title: 'Content & editorial quality',
          items: [
            {
              title: 'Content strategy',
              desc: 'I develop content that makes sense both editorially and commercially. Focus on structure, angles, and business goals.',
              icon: 'FileText'
            },
            {
              title: 'SEO-oriented and commercial content',
              desc: 'I write and shape content that is readable, credible, and built with visibility and user intent in mind.',
              icon: 'Search'
            },
            {
              title: 'Editorial development',
              desc: 'I help sharpen tone, quality, and structure across your content and editorial processes.',
              icon: 'Edit3'
            }
          ]
        },
        {
          title: 'AI & Automation in Practice',
          items: [
            {
              title: 'AI implementation in editorial processes',
              desc: 'Helping you use AI to optimize content production, research, and structure without losing human quality.',
              icon: 'Cpu'
            },
            {
              title: 'Prompt engineering for marketing and content',
              desc: 'Developing custom prompts and workflows that ensure precise and useful output from AI models.',
              icon: 'Code'
            }
          ]
        },
        {
          title: 'Strategic advisory & cross-team execution',
          items: [
            {
              title: 'Digital PR and brand communication',
              desc: 'I help strengthen stories and communication so your business stands out to partners and the market.',
              icon: 'Mic'
            },
            {
              title: 'Strategic advisory',
              desc: 'An experienced advisor who quickly understands the situation and identifies what actually creates value.',
              icon: 'Compass'
            },
            {
              title: 'Bridging teams and disciplines',
              desc: 'I work across marketing, content, affiliate, and development to create shared direction.',
              icon: 'GitMerge'
            }
          ]
        }
      ]
    },
    about: {
      heading: 'Experience, persistence, and a strong understanding of both content and business',
      body: [
        'I have worked with journalism since I was 15 years old. Since then, communication, content, and editorial quality have been a constant thread throughout my career. Over the years, I have built a strong background in journalism, content, digital PR, and editorial work.',
        'For the last 10 years, I have also worked extensively with affiliate marketing and all the disciplines that come with it: relationships, partnerships, content, performance, coordination, and commercial understanding. That means I do not look at content in isolation — I understand how content, collaboration, and business connect in practice.',
        'I am used to working with both Danish and international ecommerce businesses, major brands, developers, student assistants, and many other stakeholders. I thrive where people, processes, and goals meet — and in the role of creating clarity, momentum, and quality.',
        'I live with {{cp}}. That means my path in life and work has never been straightforward. In return, it has made me exceptionally hardworking, persistent, and solution-oriented. I bring that into everything I do: I do not give up easily, I work thoroughly, and I take both tasks and collaborations seriously.',
        'Konsulentbixen is my platform for working with companies that need more than standard solutions. I help where experience, precision, credibility, and the ability to bridge content, affiliate, relationships, and business truly matter.'
      ],
      cp_label: 'cerebral palsy',
      cp_tooltip: 'Cerebral palsy (CP) is a permanent movement disorder caused by damage to the developing brain, usually before birth. It affects muscle tone, movement, and motor skills, but not intelligence.'
    },
    experience: {
      heading: 'Broad experience — with a clear common thread',
      body: [
        'My profile has been built at the intersection of journalism, content, affiliate marketing, digital PR, and editorial work. That gives me a rare combination: I understand both the detail and the bigger picture.',
        'I have worked with content, relationships, and communication in many different contexts and with many different types of people. That means I can quickly understand new businesses, challenges, and collaborations — and turn that understanding into something concrete and useful.'
      ],
      tags: [
        'Affiliate marketing',
        'Publisher relations',
        'Content strategy',
        'SEO content',
        'AI integration',
        'Prompt engineering',
        'Journalism',
        'Editorial development',
        'Digital PR',
        'Brand communication'
      ]
    },
    projects: {
      heading: 'My Own Projects & Cases',
      subheading: 'Alongside my consulting work, I run several of my own projects where I test strategies, optimize performance, and work with affiliate marketing in practice.',
      visitLink: 'Visit site',
      items: [
        {
          title: 'AutoReception',
          link: 'https://autoreception.net/',
          desc: 'An intelligent AI solution for automated lead handling and customer reception, ensuring no inquiries are ever missed.',
          tags: ['AI', 'Automation', 'SaaS']
        },
        {
          title: 'Premium Affiliate',
          link: 'https://premiumaffiliate.io/',
          desc: 'A platform dedicated to elevating affiliate marketing through insights, tools, and strategic guidance.',
          tags: ['Affiliate', 'Growth', 'Strategy']
        },
        {
          title: 'Premium Conversion',
          link: 'https://premiumconversion.io/',
          desc: 'Optimizing conversion rates and user journeys with a focus on creating better results for publishers and webshops.',
          tags: ['CRO', 'Performance', 'UX']
        },
        {
          title: 'Premium Video',
          link: 'https://premiumvideo.io/',
          desc: 'Focused on video production and visual storytelling for affiliate marketing and e-commerce.',
          tags: ['Video', 'Content', 'Marketing']
        },
        {
          title: 'AccessInside',
          link: 'https://accessinside.net/',
          desc: "Turning formal accessibility into real guest comfort. Practical accessibility audits for hotels, cruise ships, and arenas. Combining a journalist's eye for detail with lived experience.",
          tags: ['Accessibility', 'Hospitality', 'UX']
        },
        {
          title: 'The Pitch Feed',
          link: 'https://thepitchfeed.com/',
          desc: 'My international football news agency delivering news across markets and almost all languages through automated workflows.',
          tags: ['International', 'News Agency', 'Automation']
        },
        {
          title: 'Fodbold i TV',
          link: 'https://fodbolditv.dk/da',
          desc: "Denmark's easiest overview of football on TV. The site features built-in affiliate opportunities for streaming services and bookmakers.",
          tags: ['Consumer', 'SEO', 'Affiliate']
        },
        {
          title: 'Shop Konsulentbixen',
          link: 'https://shop.konsulentbixen.dk/',
          desc: 'My own webshop where I sell curated products and test e-commerce strategies in practice.',
          tags: ['E-commerce', 'Webshop', 'Retail']
        },
        {
          title: 'Scorewidget',
          link: 'https://scorewidget.net/',
          desc: 'A B2B solution providing livescore data and sports content to publishers and media houses worldwide.',
          tags: ['B2B', 'SaaS', 'Sportsdata']
        }
      ]
    },
    customers: {
      heading: 'Clients & Collaborations',
      subheading: 'I work with everything from educational institutions to international tech companies and webshops.',
      items: [
        {
          name: 'Danish School of Media and Journalism',
          role: 'External Examiner',
          logo: 'https://gotutor.dk/img/@1/alumni/logo/danmarks-medie-og-journalisthoejskole-dmjx.png',
          desc: 'Appointed external examiner in journalism and digital journalism. Here I contribute to quality assurance and assessment of future journalists.'
        }
      ]
    },
    comparison: {
      heading: 'Find the right solution for your needs',
      subheading: 'Whether you need strategic direction, well-written content, or help growing your affiliate channels, I can step in.',
      cta: 'Which solution fits you?',
      features: {
        strategy: 'Strategic Focus',
        editorial: 'Editorial Depth',
        execution: 'Execution & Ops',
        relations: 'Relationship Work',
        ai: 'AI & Automation',
        international: 'International Reach'
      },
      tiers: [
        {
          name: 'Affiliate & Partnerships',
          focus: 'Growth & Relations',
          desc: 'Focus on bridging your brand and the right publishers to create measurable performance and long-term partnerships.',
          values: [80, 70, 100, 90, 40, 60]
        },
        {
          name: 'Content & Editorial',
          focus: 'Quality & SEO',
          desc: 'Development of credible and commercial content that speaks to both people and search engines with editorial substance.',
          values: [60, 100, 50, 60, 100, 80]
        },
        {
          name: 'AI & Automation',
          focus: 'Efficiency & Tech',
          desc: 'Implementation of AI tools and automated workflows that free up time and elevate the quality of your daily processes.',
          values: [90, 100, 60, 100, 70, 100]
        },
        {
          name: 'Strategic Sparring',
          focus: 'Direction & Growth',
          desc: 'Help creating clarity, prioritising efforts, and bridging marketing, content, and your overall business goals.',
          values: [100, 50, 80, 80, 70, 90]
        }
      ]
    },
    faq: {
      heading: 'FAQ',
      items: [
        {
          q: 'What kinds of companies do you work with?',
          a: 'I mainly work with ecommerce businesses, brands, marketing teams, content teams, and companies looking to strengthen affiliate marketing, content, or strategic communication.'
        },
        {
          q: 'How do you handle confidentiality and data?',
          a: 'Confidentiality is an absolute premise of my work. As a trained journalist, I respect confidentiality on par with source protection—one of the most sacred principles of journalism. I often work with sensitive business data and strategies, and I am happy to sign a Non-Disclosure Agreement (NDA) before we start.'
        },
        {
          q: 'Do you work with international clients?',
          a: 'Yes. I am happy to work with both Danish and international companies and am used to collaborating across markets and working styles.'
        },
        {
          q: 'Do you only help with strategy?',
          a: 'No. I can support both strategically and operationally — from analysis and direction to actual content, advisory work, and partnership development.'
        },
        {
          q: 'What is your advantage compared to a traditional agency?',
          a: 'My strength is the combination of experience, professional range, credibility, and close involvement. You work directly with a specialist who understands journalism, content, affiliate, and relationships.'
        },
        {
          q: 'Can you support both smaller and larger projects?',
          a: 'Yes. I can work on focused assignments, ongoing collaborations, and broader development projects.'
        }
      ]
    },
    contact: {
      heading: 'Let’s have an exploratory chat',
      body: 'If you are looking for an experienced partner in affiliate marketing, content, or strategic communication, I would be happy to have an exploratory chat. I work with both Danish and international clients and approach every project with seriousness, clarity, and respect for what needs to be built.',
      form: {
        name: 'Name',
        email: 'Email',
        company: 'Company',
        message: 'Message',
        send: 'Send message'
      },
      sending: 'Sending...',
      success: 'Thank you for your message! I will get back to you as soon as possible.',
      error: 'An error occurred. Please try again or send an email directly to kasper@konsulentbixen.dk.'
    },
    footer: {
      brand: 'Konsulentbixen',
      tagline1: 'Affiliate marketing, content, and strategic communication',
      tagline2: 'For Danish and international clients',
      ivmh_text: 'Proud member of Entrepreneurs with Disabilities',
      privacy: 'Cookie & Privacy Policy',
      terms: 'Terms of Business & Delivery'
    },
    whyMe: {
      heading: 'A specialist with depth, perspective, and real execution power',
      statement: 'I combine editorial quality with commercial understanding and a practical ability to move things forward.',
      items: [
        {
          title: 'Journalistic foundation',
          desc: 'I understand how to create content with quality, credibility, and precision.'
        },
        {
          title: '10 years of affiliate experience',
          desc: 'I know the discipline, the dynamics, and the partnerships from the inside.'
        },
        {
          title: 'AI & Tech Understanding',
          desc: 'I stay ahead of technological trends and understand how AI can be used as a lever for both quality and efficiency.'
        },
        {
          title: 'Commercial understanding',
          desc: 'I do not only think in words and content, but in value, performance, and business impact.'
        },
        {
          title: 'Strong relationship skills',
          desc: 'I am used to working with many different kinds of people and stakeholders.'
        },
        {
          title: 'Persistence',
          desc: 'I work hard, think carefully, and stay committed when something matters.'
        }
      ]
    },
    target: {
      heading: 'I work with companies that need more than standard solutions',
      body: 'I mainly work with companies and teams that need an experienced specialist who can step into complex situations and create direction, quality, and momentum.',
      items: [
        {
          title: 'Ecommerce businesses',
          desc: 'looking to strengthen affiliate, content, or partnerships'
        },
        {
          title: 'Brands',
          desc: 'that want sharper communication and stronger collaborations'
        },
        {
          title: 'Marketing teams',
          desc: 'that need an experienced advisor with commercial understanding'
        },
        {
          title: 'Content and editorial teams',
          desc: 'aiming to improve quality, structure, and impact'
        },
        {
          title: 'International businesses',
          desc: 'looking for a partner with both local insight and international perspective'
        }
      ]
    },
    testimonials: [
      {
        quote: 'Kasper is among the most creative, business-oriented, and curious profiles I have met in the media industry. I would hire him in a heartbeat.',
        author: 'Per Olkjær Nielsen',
        role: 'Editorial Manager',
        image: 'https://media.licdn.com/dms/image/v2/D4D22AQGB5G5mm8SB8g/feedshare-shrink_800/feedshare-shrink_800/0/1715610523658?e=2147483647&v=beta&t=SkQ0MU1ISvBcoH45wAHMltMmh230m0bpaSmlnuwxlK4',
        link: 'https://www.linkedin.com/in/perolkjaer/'
      },
      {
        quote: 'We built the affiliate business from the ground up, and laid the foundation for what it is today. Kasper was a major and important part of that, and he can be proud of what we created for Berlingske Media',
        author: 'Jacob Fischer-Nielsen',
        role: 'Sales Manager, Berlingske Media',
        image: 'https://media.licdn.com/dms/image/v2/C4E03AQG1gOr8m8X-gA/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1628511287164?e=1781740800&v=beta&t=CYwQ19oz8kgElPZeqZkAD6X4dZmJ3d-53ozddrXaFv0',
        link: 'https://www.linkedin.com/in/jacob-fischer-nielsen-9a09907/'
      }
    ],
    seo: {
      title: 'Konsulentbixen | Affiliate marketing, content, and strategic communication',
      description: 'Konsulentbixen helps Danish and international companies with affiliate marketing, content, journalism, digital PR, and strategic communication. An experienced specialist with strong editorial and commercial understanding.'
    }
  }
};